module.exports = __webpack_public_path__ + "static/media/A post-apocalyptic wasteland reclaimed by nature.914548d2.jpeg";